import React from 'react';
import {
  Modal, StyleSheet, Text, TouchableOpacity, View,
} from 'react-native';
import Colors from '../constants/Colors';
import CloseModalIcon from './CloseModalIcon';
import { logEvent } from './LogEvent';
import DeleteIcon40 from './40pxIcons/DeleteIcon40';

export default function DeleteModal(props) {
  const renderDeleteCancel = () => (
    <View
      style={{
        marginBottom: 40,
        alignSelf: 'stretch',
        paddingHorizontal: 24,
      }}
    >
      <TouchableOpacity
        style={{
          borderRadius: 4,
          alignItems: 'center',
          borderColor: Colors.light.hereworksRed500,
          borderWidth: 1,
          marginBottom: 12,
        }}
        onPress={() => {
          logEvent('DeleteModal', 'Delete');
          props.deleteAction();
          props.setModalVisible(false);
        }}
      >
        <Text
          style={{
            color: Colors.light.hereworksRed500,
            fontFamily: 'Roboto_400Regular',
            fontSize: 16,
            marginVertical: 8,
          }}
        >
          Delete
        </Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={{
          backgroundColor: '#fff',
          borderRadius: 4,
          borderWidth: 1,
          borderColor: Colors.light.hereworksLightBlue,
          alignItems: 'center',
        }}
        onPress={() => {
          logEvent('DeleteModal', 'Cancel');
          props.setModalVisible(false);
        }}
      >
        <Text
          style={{
            color: Colors.light.hereworksLightBlue,
            fontFamily: 'Roboto_400Regular',
            fontSize: 16,
            marginVertical: 8,
            marginHorizontal: 24,
          }}
        >
          Cancel
        </Text>
      </TouchableOpacity>
    </View>
  );

  return (
    <Modal
      visible={props.modalVisible}
      style={{ alignItems: 'center' }}
      presentationStyle='formSheet'
      animationType='slide'
      onRequestClose={() => props.setModalVisible(false)}>
      <View
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          alignSelf: 'center',
          borderRadius: 10,
          backgroundColor: '#fff',
        }}
      >
        <View style={{
          alignSelf: 'stretch',
          alignItems: 'center',
          padding: 16,
        }}
        >
          <Text style={{
            fontFamily: 'Poppins_600SemiBold',
            fontSize: 14,
            color: Colors.light.hereworksBlack600,
          }}>{props.title}</Text>
          <TouchableOpacity
            onPress={() => {
              logEvent('DeleteModal', 'Close_Modal');
              props.setModalVisible(false);
            }}
            style={{
              position: 'absolute',
              top: 8,
              right: 8,
              padding: 8,
            }}
          >
            <CloseModalIcon />
          </TouchableOpacity>
        </View>
        <DeleteIcon40 style={{ marginTop: 60 }} />
        <Text
          style={{
            fontSize: 28,
            fontFamily: 'Poppins_600SemiBold',
            color: Colors.light.hereworksRed500,
            marginTop: 27,
            marginBottom: 12,
            textAlign: 'center',
          }}
        >
          {props.title}?
        </Text>
        <View
          style={{
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'center',
            marginBottom: 27,
            marginHorizontal: 24,
            flex: 1,
          }}
        >
          <Text style={styles.description}>Do you want to delete&nbsp;</Text>
          <Text style={styles.nameStyle}>{props.name}</Text>
          {props.name !== undefined && <Text style={styles.description}>&nbsp;from the&nbsp;</Text>}
          {props.groupName ? <Text style={styles.nameStyle}>{props.groupName}</Text> : null}
          {props.groupName ? <Text
            style={styles.description}>&nbsp;group?</Text> : <Text style={styles.description}>
              &nbsp;users list?</Text>}
        </View>
        {renderDeleteCancel()}
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  description: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    color: Colors.light.hereworksBlack400,
  },
  nameStyle: {
    fontFamily: 'Roboto_700Bold',
    fontSize: 14,
    color: Colors.light.hereworksBlack400,
  },
});
